import { mediaGQLFields } from '../media/index.js';
import { networkAuthMemberPropsGQLFields, } from '../permission/index.js';
import { navigationSlatesGQLFields, } from '../slate/index.js';
import { spaceGQLFields } from '../space/index.js';
import { newThemesGQLFields, themesGQLFields, } from '../theme/index.js';
import { customFieldsSchemaGQLFields, } from './customFieldsSchema.fields.js';
import { customCodeGQLFields, topNavigationGQLFields } from './network.gql.js';
import { planGQLFields } from './plan.fields.js';
import { roleGQLFields } from './role.fields.js';
const BASIC_NETWORK_FIELDS = {};
const ALL_NETWORK_FIELDS = {
    activeTheme: 'basic',
    themes: 'basic',
    topNavigation: 'basic',
    logo: 'basic',
    favicon: 'basic',
    whoCanInvite: 'basic',
    defaultSpaces: 'basic',
    roles: 'basic',
    customCode: 'basic',
    authMemberProps: 'basic',
    subscriptionPlan: 'basic',
    systemSpaces: 'basic',
    memberFields: 'basic',
    customSeoDetail: 'basic',
};
const DEFAULT_NETWORK_FIELDS = {
    authMemberProps: 'all',
    customCode: 'all',
    defaultSpaces: {
        image: 'basic',
    },
    favicon: 'all',
    logo: 'all',
    roles: 'all',
    navigationSlates: 'all',
    themes: 'all',
    activeTheme: 'all',
    topNavigation: 'all',
    whoCanInvite: 'all',
    subscriptionPlan: 'all',
    systemSpaces: 'all',
    memberFields: 'all',
    customSeoDetail: 'all',
};
export function networkGQLFields(fields) {
    var _a, _b;
    if (fields === 'basic')
        fields = BASIC_NETWORK_FIELDS;
    if (fields === 'all')
        fields = ALL_NETWORK_FIELDS;
    if (fields === 'default')
        fields = DEFAULT_NETWORK_FIELDS;
    return `
    id
    companyName
    name
    description
    visibility
    membership
    logoId
    faviconId
    locale
    domain
    newDomain
    incidentEmails
    privacyPolicyUrl
    termsOfServiceUrl
    brandColor
    billingEmail
    status
    memberCapacity
    memberCapacityDeclared
    passwordComplexity
    seatsCapacity
    additionalSeatsCapacity
    seatCapacityDeclared
    tribeBranding
    whoCanInviteIds
    hideDefaultAuthenticationForm
    releaseChannel
    landingPages {
      landingPageForGuest
      landingPageForMember
      landingPageForNewMember
    }
    activeSso {
      logoutUrl
      settingsUrl
    }
    ${fields.navigationSlates
        ? `
      navigationSlates {
        ${navigationSlatesGQLFields(fields.navigationSlates)}
      }
    `
        : ``}
    ${fields.activeTheme
        ? `
      activeTheme {
        ${newThemesGQLFields(fields.activeTheme)}
      }
    `
        : ``}
    ${fields.themes
        ? `
      themes {
        ${themesGQLFields(fields.themes)}
      }
    `
        : ``}
    ${fields.topNavigation
        ? `
      topNavigation {
        ${topNavigationGQLFields(fields.topNavigation)}
      }
    `
        : ``}
    ${fields.logo
        ? `
      logo {
        ${mediaGQLFields(fields.logo)}
      }
    `
        : ``}
    ${fields.favicon
        ? `
      favicon {
        ${mediaGQLFields(fields.favicon)}
      }
    `
        : ``}
    ${fields.whoCanInvite
        ? `
      whoCanInvite {
        ${roleGQLFields(fields.whoCanInvite)}
      }
    `
        : ``}
    ${fields.defaultSpaces
        ? `
      defaultSpaces {
        ${spaceGQLFields(fields.defaultSpaces)}
      }
    `
        : ``}
    ${fields.roles
        ? `
      roles {
        ${roleGQLFields(fields.roles)}
      }
    `
        : ``}
    ${fields.customCode
        ? `
      customCodes(anonymize: false) {
        ${customCodeGQLFields(fields.customCode)}
      }
    `
        : ``}
    ${fields.authMemberProps
        ? `
      authMemberProps {
        ${networkAuthMemberPropsGQLFields(fields.authMemberProps)}
      }
    `
        : ``}
    ${fields.subscriptionPlan
        ? `
      subscriptionPlan {
        ${planGQLFields(fields.subscriptionPlan)}
      }
    `
        : ``}
    ${fields.systemSpaces
        ? `
      systemSpaces {
        ${spaceGQLFields(fields.systemSpaces)}
      }
    `
        : ``}
    ${fields.memberFields
        ? `
      memberFields {
        ${customFieldsSchemaGQLFields(fields.memberFields)}
      }
    `
        : ``}
    ${(fields === null || fields === void 0 ? void 0 : fields.customSeoDetail)
        ? `
      customSeoDetail {
        description
        noIndex
        thumbnail {
          ${mediaGQLFields('basic')}
        }
        thumbnailId
        title
      }
    `
        : ``}
    ${(fields === null || fields === void 0 ? void 0 : fields.extraProperties)
        ? `
      extraProperties ${((_b = (_a = fields === null || fields === void 0 ? void 0 : fields.extraProperties) === null || _a === void 0 ? void 0 : _a.variables) === null || _b === void 0 ? void 0 : _b.keys)
            ? `(keys: ["${fields.extraProperties.variables.keys.join('","')}"])`
            : ``} {
        key
        value
      }
    `
        : ``}
  `;
}
//# sourceMappingURL=network.fields.js.map